/*
 * Display name and emoji per backend sport key.
 *
 * Mirrors _SPORT_META in api/routes/sports.py. Endpoints that group by sport
 * (GET /api/public/accuracy → by_sport) return the bare key — 'american_football'
 * — with no label, so the presentation lives here.
 *
 * An unknown key falls back to a tidied version of itself rather than being
 * dropped, so a sport added on the backend still appears.
 */
const SPORT_META = {
  soccer: { name: 'Soccer', emoji: '⚽' },
  basketball: { name: 'Basketball', emoji: '🏀' },
  american_football: { name: 'Am. Football', emoji: '🏈' },
  handball: { name: 'Handball', emoji: '🤾' },
  hockey: { name: 'Hockey', emoji: '🏒' },
  mma: { name: 'MMA', emoji: '🥊' },
  rugby: { name: 'Rugby', emoji: '🏉' },
  volleyball: { name: 'Volleyball', emoji: '🏐' },
  cricket: { name: 'Cricket', emoji: '🏏' },
};

export function sportMeta(key) {
  const known = SPORT_META[key];
  if (known) return known;

  const name = String(key ?? '')
    .replace(/_/g, ' ')
    .replace(/\b\w/g, (c) => c.toUpperCase());
  return { name: name || 'Other', emoji: '🏆' };
}
